import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

declare global {
  interface Window {
    Paddle?: {
      Setup: (config: { seller: number; environment?: string }) => void;
      Environment: { set: (env: string) => void };
      Checkout: {
        open: (config: {
          transactionId: string;
          settings?: {
            successUrl?: string;
          };
        }) => void;
      };
    };
    __paddleInitialized?: boolean;
  }
}

const PADDLE_SELLER_ID = 277220;
const PADDLE_ENVIRONMENT = 'production';

export const usePaddleCheckout = () => {
  const initialized = useRef(false);
  const navigate = useNavigate();



  useEffect(() => {
    if (initialized.current || typeof window === 'undefined') return;

    const initPaddle = () => {
      if (window.Paddle && !window.__paddleInitialized) {
        window.Paddle.Environment.set(PADDLE_ENVIRONMENT);
        window.Paddle.Setup({
          seller: PADDLE_SELLER_ID,
        });
        window.__paddleInitialized = true;
        initialized.current = true;
        console.log('Paddle.js initialized (environment:', PADDLE_ENVIRONMENT, ')');
      }
    };

    if (window.Paddle) {
      initPaddle();
      return;
    }

    const interval = setInterval(() => {
      if (window.Paddle) {
        initPaddle();
        clearInterval(interval);
      }
    }, 200);

    return () => {
      clearInterval(interval);
    };
  }, []);
  const openCheckout = useCallback((transactionId: string, options?: { successUrl?: string }) => {
    if (!window.Paddle) {
      toast.error('Payment system is loading. Please try again in a moment.');
      return;
    }

    const successUrl = options?.successUrl ?? `${window.location.origin}/pricing?success=true`;

    window.Paddle.Checkout.open({
      transactionId,
      settings: {
        successUrl,
      },
    });
  }, []);

  return { openCheckout };
};
